module.exports = __webpack_public_path__ + "img/media-5.19a219ec.png";